

<section class="px-5 mt-4">

   <div class="col-12 px-5  d-flex justify-content-between">
    <h2 class="text-left text-white my-4">Lista de Pagos.</h2>
    <div class="d-flex justify-content-center align-items-center">
        <form [formGroup]="OptionForm">
          <div class="col-12 text-end d-flex justify-content-center align-items-center">
            <select class="custom-outline-input form-select mt-3 mx-3 my-3"
              (change)="actionSelectOption()"
              aria-label="Default select example" id="option" formControlName="option">
              <option value="0">Seleccione...</option>
              <option value="{{option.id}}" *ngFor="let option of ListOption">
                {{option.name}}
              </option>
            </select>
            <input *ngIf="this.optionChange == 2" type="number" placeholder="Num. Factura" class="form-control custom-outline-input mx-3" (keyup)="change($event)">
            <input *ngIf="this.optionChange == 3" type="number" placeholder="Num. Hes" class="form-control custom-outline-input mx-3" (keyup)="change($event)">
            <button class="btn btn-outline-light" (click)="filtar()">
              <span class="m-1">Filtrar</span>
            </button>
          </div>
        </form>
    </div>
  </div>
 
   
  

    <div class="container-fluid px-5">
      <div class="backgroundTable">
  
      
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes">
          
          <ng-container *ngIf="ListPay.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="ListPay.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Projecto</th>
              <th class="text-white text-center">Cliente</th>
              <th class="text-white text-center">Fecha</th>
              <th class="text-white text-center">Estado</th>
              <th class="text-white text-center">Opciones</th>

          </thead>

          <tbody>
            <tr *ngFor="let pay of ListPay">
 
              <td class="text-center">{{pay.project}}</td>
              <td class="text-center">{{pay.client}}</td>
              <td class="text-center">{{pay.date}}</td>
              <td >
                <div class="p-2 bd-highlight d-flex flex-column">
                    <span *ngIf="pay.stado === 'Pagos Incompletos'"
                      class="badge rounded-pill text-bg-anulado p-2" style="font-size: 12px;">{{pay.stado}}</span>
                    <span *ngIf="pay.stado === 'Sin Pagos'"
                      class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">{{pay.stado}}</span>
                    <span *ngIf="pay.stado === 'Pagos Completos'"
                      class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">{{pay.stado}}</span>
                </div>
              </td>

              
              <td class="text-center">
                <button class="rounded-pill btn btn-outline-light mx-2 my-3 " [routerLink]="['/pdg/finance/pay/list', pay.id, pay.project, pay.client]"  >
                  <span class="m-1">Ver Pagos</span>
              </button>
              </td>
             
              
           
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
  </section>
